/* eslint-disable camelcase */
import React, { useState } from 'react';
import { Pannellum } from 'pannellum-react';
import Section from './section';


const SCENES = {
  default: {
    image: '/tour/parking.jpeg',
    title: 'Парковка',
    spots: [
      {
        pitch: 0,
        yaw: -3,
        handleClickArg: { name: 'first_floor' },
        name: 'parking_to_first_floor',
        text: 'Info Hotspot Text 3',
      },
    ],
  },
  first_floor: {
    image: '/tour/first_floor.jpeg',
    title: 'Первый Этаж',
    spots: [
      {
        pitch: 0,
        yaw: -110,
        handleClickArg: { name: 'second_floor' },
        name: 'second_floor',
      },
      {
        pitch: 5,
        yaw: -28,
        handleClickArg: { name: 'room_3' },
        name: 'room_3',
      },
      {
        pitch: 5,
        yaw: -15,
        handleClickArg: { name: 'room_4' },
        name: 'room_4',
      },
      {
        pitch: 0,
        yaw: 0,
        handleClickArg: { name: 'room_5' },
        name: 'room_5',
      },
      {
        pitch: 0,
        yaw: 150,
        handleClickArg: { name: 'default' },
        name: 'first_floor_to_parking',
      },
    ],
  },
  room_3: {
    image: '/tour/room_3.jpeg',
    title: 'Комната №3',
    spots: [
      {
        pitch: 0,
        yaw: -90,
        handleClickArg: { name: 'first_floor' },
        name: 'room_3_to_first_floor',
      },
    ],
  },
  room_4: {
    image: '/tour/room_4.jpeg',
    title: 'Комната №4',
    spots: [
      {
        pitch: -1,
        yaw: -132,
        handleClickArg: { name: 'first_floor' },
        name: 'room_4_to_first_floor',
      },
    ],
  },
  room_5: {
    image: '/tour/room_5.jpeg',
    title: 'Комната №5',
    spots: [
      {
        pitch: 0,
        yaw: 143,
        handleClickArg: { name: 'first_floor' },
        name: 'room_5_to_first_floor',
      },
    ],
  },
  second_floor: {
    image: '/tour/second_floor.jpeg',
    title: 'Второй Этаж',
    spots: [
      {
        pitch: -20,
        yaw: -90,
        handleClickArg: { name: 'first_floor' },
        name: 'first_floor',
      },
      {
        pitch: -1,
        yaw: -10,
        handleClickArg: { name: 'room_6' },
        name: 'room_6',
      },
      {
        pitch: -1,
        yaw: 10,
        handleClickArg: { name: 'room_7' },
        name: 'room_7',
      },
      {
        pitch: 0,
        yaw: 75,
        handleClickArg: { name: 'room_8' },
        name: 'room_8',
      },
      {
        pitch: 0,
        yaw: -110,
        handleClickArg: { name: 'lounge' },
        name: 'lounge',
      },
      {
        pitch: -5,
        yaw: -185,
        handleClickArg: { name: 'terrace' },
        name: 'lounge',
      },
    ],
  },
  room_6: {
    image: '/tour/room_6.jpeg',
    title: 'Комната №6',
    spots: [
      {
        pitch: 0,
        yaw: 135,
        handleClickArg: { name: 'second_floor' },
        name: 'room_6_to_second_floor',
      },
    ],
  },
  room_7: {
    image: '/tour/room_7.jpeg',
    title: 'Комната №7',
    spots: [
      {
        pitch: -1,
        yaw: 220,
        handleClickArg: { name: 'second_floor' },
        name: 'room_7_to_second_floor',
      },
    ],
  },
  room_8: {
    image: '/tour/room_8.jpeg',
    title: 'Комната №8',
    spots: [
      {
        pitch: 0,
        yaw: 180,
        handleClickArg: { name: 'second_floor' },
        name: 'room_8_to_second_floor',
      },
    ],
  },
  lounge: {
    image: '/tour/lounge.jpeg',
    title: 'Зона Отдыха',
    spots: [
      {
        pitch: 0,
        yaw: -140,
        handleClickArg: { name: 'pool' },
        name: 'lounge_to_pool',
      },
      {
        pitch: -10,
        yaw: 130,
        handleClickArg: { name: 'second_floor' },
        name: 'lounge_to_second_floor',
      },
    ],
  },
  pool: {
    image: '/tour/pool.jpeg',
    title: 'Бассейн',
    spots: [
      {
        pitch: -15,
        yaw: -120,
        handleClickArg: { name: 'lounge' },
        name: 'pool_to_lounge',
      },
    ],
  },
  terrace: {
    image: '/tour/terrace.jpeg',
    title: 'Терасса',
    spots: [
      {
        pitch: -5,
        yaw: -112,
        handleClickArg: { name: 'second_floor' },
        name: 'terrace_to_second_floor',
      },
    ],
  },
};


const Tour = () => {

  const [scene, setScene] = useState(SCENES.default);

  const hotspots = scene.spots.map(spot => (
    <div
      key={spot.name}
      type="custom"
      handleClick={(_, { name }) => setScene(SCENES[name])}
      {...spot}
    />
  ));

  return (
    <Section title="3D Тур" className="tour">
      {typeof window !== 'undefined' && Pannellum && (
        <Pannellum
          width="100%"
          height="500px"
          image={scene.image}
          pitch={0}
          yaw={0}
          type="equirectangular"
          previewTitle={scene.title}
          autoLoad
          orientationOnByDefault
          showZoomCtrl
          autoRotate={-2}
        >
          {hotspots}
        </Pannellum>
      )}
    </Section>
  );
};

export default Tour;
